import { useEffect, useState } from "react";
import { getStats } from "../lib/api";

export const StatsStrip = () => {
  const [stats, setStats] = useState([]);
  useEffect(() => { getStats().then(setStats).catch(() => setStats([])); }, []);
  if (!stats.length) return null;

  return (
    <div className="stats" data-testid="stats-strip">
      <div className="wrap">
        <div className="stats-grid" style={{ gridTemplateColumns: `repeat(${Math.min(stats.length, 4)}, 1fr)` }}>
          {stats.map((s) => (
            <div className="stat" key={s.id} data-testid={`stat-${s.value}`}>
              <div className="n">{s.value}</div>
              <div className="l">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
